// extracted by mini-css-extract-plugin
module.exports = {"container":"SegmentedControl_container__30QH0","inactiveItem":"SegmentedControl_inactiveItem__2Kwp3","activeItem":"SegmentedControl_activeItem__3ajKm"};